import {
    tentativeProposeNewTimeEventFormatString,
    declinedProposeNewTimeEventFormatString,
    acceptedEventFormatString,
    tentativeEventFormatString,
    declinedEventFormatString,
} from './MeetingResponseInfo.locstring.json';
import loc, { format } from 'owa-localize';
import EditEventLink from './EditEventLink';
import getEventTypeString from '../utils/getEventTypeString';
import * as classnames from 'classnames';
import { observer } from 'mobx-react';
import { Icon, IIconProps } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { MailIcons } from 'owa-mail-icons';
import MeetingResponseMessage from 'owa-service/lib/contract/MeetingResponseMessageType';

import formatMeetingTimeSpan from 'owa-timeformat/lib/utils/formatMeetingTimeSpan';
import { trace } from 'owa-trace';
import * as React from 'react';
import { MeetingMessageActionType } from '../utils/MeetingMessageActionType';

const styles = require('./MeetingResponseInfo.scss');
const detailStyles = require('./MeetingDetails.scss');

export interface MeetingResponseInfoProps {
    item: MeetingResponseMessage;
    logAction: (interactionType: MeetingMessageActionType, propertyNames?: string[]) => void;
}

@observer
export default class MeetingResponseInfo extends React.Component<MeetingResponseInfoProps, {}> {
    render() {
        const { item } = this.props;

        if (item.ProposedStart && item.ProposedEnd) {
            return this.renderProposeNewTimeResponse();
        } else {
            return this.renderStandardResponse();
        }
    }

    /** When the respondent has not proposed a new time */
    private renderStandardResponse() {
        const { item } = this.props;

        return (
            <div className={styles.response}>
                <Icon {...this.getIconProps()} className={styles.icon} />
                <span>
                    {format(
                        this.getFormatString(),
                        item.Sender.Mailbox.Name,
                        getEventTypeString(this.props.item)
                    )}
                </span>
            </div>
        );
    }

    /** When the respondent has proposed a new time */
    private renderProposeNewTimeResponse() {
        const { item, logAction } = this.props;

        return (
            <div className={styles.proposeNewTime}>
                <div className={detailStyles.detailsRow}>
                    <Icon className={styles.clockIcon} iconName={MailIcons.DateTime2} />
                    <div className={styles.details}>
                        <div className={styles.message}>
                            {format(
                                item.ResponseType === 'Tentative'
                                    ? loc(tentativeProposeNewTimeEventFormatString)
                                    : loc(declinedProposeNewTimeEventFormatString),
                                item.Sender.Mailbox.Name,
                                getEventTypeString(this.props.item)
                            )}
                        </div>
                        <div className={styles.newTime}>
                            {formatMeetingTimeSpan(item.ProposedStart, item.ProposedEnd)}
                        </div>
                    </div>
                </div>
                <EditEventLink item={item} logAction={logAction} />
            </div>
        );
    }

    private getIconProps(): IIconProps {
        return this.getResponseTypeData(
            {
                iconName: ControlIcons.EventAccepted,
                styles: {
                    root: classnames(styles.accept, styles.icon),
                },
            },
            {
                iconName: ControlIcons.EventTentative,
                styles: {
                    root: classnames(styles.tentative, styles.icon),
                },
            },
            {
                iconName: ControlIcons.EventDeclined,
                styles: {
                    root: classnames(styles.decline, styles.icon),
                },
            }
        );
    }

    private getFormatString(): string {
        return this.getResponseTypeData(
            loc(acceptedEventFormatString),
            loc(tentativeEventFormatString),
            loc(declinedEventFormatString)
        );
    }

    private getResponseTypeData<T>(accept: T, tentative: T, decline: T): T {
        const itemClass = this.props.item.ItemClass;
        if (itemClass.match(/^ipm\.schedule\.meeting\.resp\.pos/i)) {
            return accept;
        } else if (itemClass.match(/^ipm\.schedule\.meeting\.resp\.tent/i)) {
            return tentative;
        } else if (itemClass.match(/^ipm\.schedule\.meeting\.resp\.neg/i)) {
            return decline;
        } else {
            trace.error('Unknown meeting response type');
            return null;
        }
    }
}
